<template>
    <div class="edu-details">
        <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{$t('registration.tabs.tabEducationDetails')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">51%</h2>
            </div>
          </div>
        </div>
          <form class="row justify-content-center" action="POST" v-on:submit.prevent="saveDetails('educationForm')" data-vv-scope="educationForm">
       <div class="col-12">
       <div class="form-group custom-input">
            <div v-if="qualification === null || qualification.qualificationTypeID !== 8">
                <div class="para">{{$t('candidateProfile.educationDetails.lblPassedOrAppeared')}}</div> 
                <v-select :v-on:change="changeStatusSelection(qualificationStatus)" label="name" :class="{'form-error': errors.has('qualification status')}" v-model="qualificationStatus" :options="qualificationStatusList" :error-messages="errors.collect('qualificationStatus')" v-validate="'required|not_in:Select'" data-vv-name="qualification status" name="name" :placeholder="$t('candidateProfile.educationDetails.plceQualificationStatus')" required></v-select>
                 <sup>
                    <i class="mdi mdi-star text-danger"></i>
                </sup>
                 <div class="para">{{$t('candidateProfile.educationDetails.lblIn')}}</div> 
                <v-select :v-on:change="changeSelection(qualification)" label="name" :class="{'form-error': errors.has('qualification details')}" v-model="qualification" :options="filterQualificationList" :error-messages="errors.collect('qualification')" v-validate="'required|not_in:Select'" data-vv-name="qualification details" name="name" :placeholder="$t('candidateProfile.educationDetails.plceQualification')" required></v-select>
                 <sup>
                    <i class="mdi mdi-star text-danger"></i>
                </sup>
                <div class="para">{{$t('candidateProfile.educationDetails.lblExam')}}</div> 
            </div>
            <div v-if="qualification !== null && qualification.qualificationTypeID === 8">
                <div class="para">I </div> 
                <v-select label="name" :v-on:change="changeSelection(qualification)" :class="{'form-error': errors.has('qualification details')}" v-model="qualification" :options="qualificationList" :error-messages="errors.collect('qualification')" v-validate="'required|not_in:Select'" data-vv-name="qualification details" name="name" :placeholder="$t('candidateProfile.educationDetails.plceQualification')" required></v-select>
                <sup>
                    <i class="mdi mdi-star text-danger"></i>
                </sup>
                <div class="para">{{$t('candidateProfile.educationDetails.lblHscOrDiploma')}} </div>
            </div>
        </div>
    </div>
  </form>  
  <div class=" row text-center p-3">
    <button type="button" class="btn btn btn-info-alt mr-3" @click="prevTabFunc"> {{$t('button.back')}}</button>
    <button type="button" class="btn btn btn-orange ml-auto" @click="nextTabFunc"> {{$t('button.next')}}</button>
  </div>
    <modal class="sm hide-header" v-if="showModal" @close="showModal = false">
      <h5 slot="header" class="text-center">{{$t('candidateProfile.educationDetails.lblConfiramtion')}}</h5>   
    <p slot="body" class="green">
      <span class="red">{{$t('candidateProfile.educationDetails.lblNote')}} </span> {{$t('candidateProfile.educationDetails.lblName')}}
    </p>
    <div slot="footer">
      <b-link class="btn btn-success-alt mr-3"  to="agreement">{{$t('button.yes')}}</b-link>
      <button type="button" class="btn btn-info-alt" @click="showModal = false">{{$t('button.no')}}</button>
    </div>
    </modal>
  </div>
</template>
<script>
import modal from '@/components/common/modal.vue'
import axios from 'axios'
axios.default.baseURL = ''
export default {
  name: 'EducationalDetails',
  components: {
    modal
  },
  data () {
    return {
      showModal: false,
      student: { },
      qualification: '',
      qualificationStatus: null,
      qualificationList: [],
      filterQualificationList: [],
      qualificationStatusList: [
        {
          'id': 1,
          'name': 'have passed'
        },
        {
          'id': 2,
          'name': 'am appearing'
        },
        {
          'id': 8,
          'name': 'never appeared'
        }
      ]
    }
  },
  methods: {
    nextTabFunc () {
      this.saveDetails()
    },
    prevTabFunc () {
      this.$router.push('address')
    },
    changeStatusSelection: function (item) {
      if (item == null) {
        return false
      }
      if (item.id === 8) {
        this.qualificationStatus = this.qualificationStatusList[0]
        for (let i in this.qualificationList) {
          if (this.qualificationList[i].qualificationTypeID === item.id) {
            this.qualification = this.qualificationList[i]
          }
        }
      }
    },
    changeSelection: function (item) {
      if (item == null) {
        return false
      }
      if (item.qualificationTypeID === 8) {
        this.qualificationStatus = this.qualificationStatusList[0]
      }
    },
    saveDetails: function (scope) {
      var self = this
      return this.$validator
        .validate()
        .then(result => {
          if (result) {
            if (this.qualification.qualificationTypeID !== 8) {
              this.student.isSSCPassed = true
              this.student.isEligibile = true
              if (this.qualification.qualificationTypeID === 2 && this.qualificationStatus.id === 1) {
                this.student.isHSCPassed = true
                this.student.isDiplomaPassed = false
                this.student.neverAppeared = false
                this.student.isHSCAppeared = false
                this.student.isDiplomaAppeared = false
              } else if (this.qualification.qualificationTypeID === 2 && this.qualificationStatus.id === 2) {
                this.student.isHSCPassed = false
                this.student.isDiplomaPassed = false
                this.student.neverAppeared = false
                this.student.isHSCAppeared = true
                this.student.isDiplomaAppeared = false
              } else if (this.qualification.qualificationTypeID === 3 && this.qualificationStatus.id === 1) {
                this.student.isHSCPassed = false
                this.student.isHSCAppeared = false
                this.student.isDiplomaPassed = true
                this.student.neverAppeared = false
                this.student.isDiplomaAppeared = false
              } else if (this.qualification.qualificationTypeID === 3 && this.qualificationStatus.id === 2) {
                this.student.isHSCPassed = false
                this.student.isHSCAppeared = false
                this.student.isDiplomaPassed = false
                this.student.neverAppeared = false
                this.student.isDiplomaAppeared = true
              }
            } else {
              this.student.isSSCPassed = false
              this.student.isHSCPassed = false
              this.student.isDiplomaPassed = false
              this.student.isEligibile = false
              this.student.isDiplomaAppeared = false
              this.student.isHSCAppeared = false
              this.student.neverAppeared = true
            }
            if (this.student.isEligibile !== false) {
              var profileUser = this.$store.state.candidateProfile.profileUser
              return axios.post('/r/candidateProfile/updateEducationDetails/' + profileUser, this.student).then(response => {
                if (response.data !== null && response.data === 'true') {
                  this.$toasted.success(self.$t('toastr.toastrEducationalDetailsSaved'), {
                    theme: 'bubble',
                    duration: this.TOASTR_TIME
                  })
                  this.$router.push('documentsupload')
                  return true
                } else {
                  this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
                    theme: 'bubble',
                    duration: this.TOASTR_TIME
                  })
                  return false
                }
              }).catch(e => {
                this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
                  theme: 'bubble',
                  duration: this.TOASTR_TIME
                })
                console.error(e)
                return false
              })
            } else {
              this.showModal = true
            }
          }
          if (this.qualification === undefined || this.qualification === null || this.qualification === '') {
            this.$toasted.error(self.$t('candidateProfile.educationDetails.toastrSelectQualification'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          } else if ((this.qualificationStatus === undefined || this.qualificationStatus === null || this.qualificationStatus === '') && this.qualification.qualificationTypeID !== 8) {
            this.$toasted.error(self.$t('candidateProfile.educationDetails.toastrSelectQualificationStatus'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          }
          return false
        })
        .catch(e => {
          console.error(e)
          return false
        })
    },
    getPreviousQualificationDetails: function () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      axios.get('/r/candidateProfile/getQualificationDetails/' + profileUser).then(response => {
        if (response.data !== null) {
          this.student = response.data
          if (this.student.isHSCPassed === true || this.student.isHSCAppeared === true) {
            for (let index = 0; index < this.qualificationList.length; index++) {
              if (this.qualificationList[index].qualificationTypeID === 2) {
                this.qualification = this.qualificationList[index]
                break
              }
            }
            this.qualificationStatus = this.qualificationStatusList[0]
            if (this.student.isHSCAppeared === true) {
              this.qualificationStatus = this.qualificationStatusList[1]
            }
          } else if (this.student.isDiplomaPassed === true || this.student.isDiplomaAppeared === true) {
            for (let index = 0; index < this.qualificationList.length; index++) {
              if (this.qualificationList[index].qualificationTypeID === 3) {
                this.qualification = this.qualificationList[index]
                break
              }
            }
            this.qualificationStatus = this.qualificationStatusList[0]
            if (this.student.isDiplomaAppeared === true) {
              this.qualificationStatus = this.qualificationStatusList[1]
            }
          } else if (this.student.neverAppeared === true) {
            for (let index = this.qualificationList.length - 1; index >= 0; index--) {
              if (this.qualificationList[index].qualificationTypeID === 8) {
                this.qualification = this.qualificationList[index]
                break
              }
            }
          }
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    fetchEducationLevel () {
      var self = this
      axios.get('/r/getEducationLevel').then(response => {
        this.qualificationList = response.data
        this.filterQualificationList.push(...this.qualificationList)
        for (var i in this.filterQualificationList) {
          if (this.filterQualificationList[i].qualificationTypeID === 8) {
            delete this.filterQualificationList[i]
          }
        }
        this.getPreviousQualificationDetails()
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.fetchEducationLevel()
    }
  }
}
</script>
<style lang="scss">
.green{
color: green
}
// .edu-details{
// .card-edu{
//     margin-top:-20px;
// }

// .radio-wrap{
//     padding-left:25px;
//     /* The container */
// .radiocss {
//     display: inline-block;
//     position: relative;
//     padding-left: 25px;
//     padding-right: 25px;
//     margin-bottom: 12px;
//     cursor: pointer;
//     -webkit-user-select: none;
//     -moz-user-select: none;
//     -ms-user-select: none;
//     user-select: none;
// }

// /* Hide the browser's default radio button */
// .radiocss input {
//     position: absolute;
//     opacity: 0;
//     cursor: pointer;
// }

// /* Create a custom radio button */
// .checkmark {
//     position: absolute;
//     top: 0;
//     left: 0;
//     height: 18px;
//     width: 18px;
//     background-color: darken(#F3F5F7, 10%);
//     border-radius: 50%;
// }

// /* On mouse-over, add a grey background color */
// .radiocss:hover input ~ .checkmark {
//     background-color: darken(#F3F5F7, 20%);
// }

// /* When the radio button is checked, add a blue background */
// .radiocss input:checked ~ .checkmark {
//     background-color: rgb(72, 133, 237);
// }

// /* Create the indicator (the dot/circle - hidden when not checked) */
// .checkmark:after {
//     content: "";
//     position: absolute;
//     display: none;
// }

// /* Show the indicator (dot/circle) when checked */
// .radiocss input:checked ~ .checkmark:after {
//     display: block;
// }

// /* Style the indicator (dot/circle) */
// .radiocss .checkmark:after {
//  	top: 5px;
// 	left: 5px;
// 	width: 8px;
// 	height: 8px;
// 	border-radius: 50%;
// 	background: white;
// }
//  input[type='radio'], input[type=radio] {
//     margin-left:23px;
//     display: inline-block;
//     }

// }
        // }

</style>



// WEBPACK FOOTER //
// src/components/registration/educationalDetails.vue